<template>
  <div class="app-container">
    <navigation title="文津经典诵读"></navigation>
    <div class="content">
      <div class="calendar-detail">
        <div v-if="poetry.dateInfo" class="weekday">{{poetry.dateInfo.dayOfWeek}}</div><span class="bar"></span>
        <div class="today-date" v-if="poetry.dateInfo">
          <p class="dayOfMonth">{{poetry.dateInfo.dayOfMonth}}</p>
          <p class="yearMonth">{{poetry.dateInfo.yearMonth}}</p>
        </div><span class="bar"></span>
        <div v-if="poetry.dateInfo" class="chineseYear">{{poetry.dateInfo.chineseYear}}</div><span class="bar"></span>
        <div class="previous" @click="review">
          <svg-icon iconClass='date' className='icon' class="date"></svg-icon>
          <div class="previous-text">往期回顾</div>
        </div>
      </div>
      <div class="poetry-title">诗词名句</div>
      <div class="poetry-content">
        <div class="audio motto-audio" v-if="poetry.audioPath">
          <audio ref="motto" @loadedmetadata="fillTime($event)" @timeupdate.stop="updateProgress" @ended.stop="audioEnded(1)">
            <source :src="baseUrl+poetry.audioPath"  type="audio/mp3"/>
          </audio>
          <div class="motto-left" @click="mottoAudio">
            <img v-if="mottoPlay" src="@/assets/img/pr-play.png" alt="" class="audio-play">
            <img v-else src="@/assets/img/pr-pause.png" alt="" class="audio-pause">
          </div>
          <div class="motto-right">
            <div class="progress-strip">
              <div class="progressBar">
                <div class="timeBar" style="width:0px"></div>
              </div>
            </div>
            <div class="time">
              <div class="time-start">{{ audioArr.currentTime }}</div>
              <div class="time-end">{{ audioArr.duration }}</div>
            </div>
          </div>
        </div>
        <div class="poetry-text">
          <div class="poetry-details">
            <div class="poetry-details-text" v-html="poetry.sectionText"></div>
            <div class="poetry-details-source">———{{poetry.year?'（'+poetry.year +'）': '' }}{{ poetry.author }}{{ poetry.title?poetry.title:'' }}</div>
          </div>
          <div class="translation">
            <span class="translation-title"></span>
            <span class="translationText">{{poetry.translationText}}</span>
          </div>
          <div class="poem">
            <p></p>
            <div class="fullText" v-html="poetry.fullText"></div>
          </div>
        </div>
      </div>
      <div class="poetry-title">美德格言</div>
      <div class="motto-content">
        <div class="audio today-audio" v-if="poetry.mottoAudio">
          <audio ref="virtue" @loadedmetadata="fillTime($event)" @timeupdate.stop="updateProgress" @ended.stop="audioEnded()">
            <source :src="baseUrl+poetry.mottoAudio"  type="audio/mp3"/>
          </audio>
          <div class="motto-left">
            <img v-if="virtuePlay" src="@/assets/img/pr-play.png" alt="" class="audio-play" @click="play">
            <img v-else src="@/assets/img/pr-pause.png" alt="" class="audio-pause" @click="pause">
          </div>
          <div class="motto-right">
            <div class="progress-strip">
              <div class="progressBar">
                <div class="timeBarV" style="width:0px"></div>
              </div>
            </div>
            <div class="time">
              <div class="time-start">{{ virtueArr.currentTime }}</div>
              <div class="time-end">{{ virtueArr.duration }}</div>
            </div>
          </div>
        </div>
        <div class="motto-text">
          <div class="poetry-details">
            <div class="poetry-details-text">{{ poetry.mottoSection }}</div>
            <div class="poetry-details-source">———{{poetry.mottoYear?'（'+poetry.mottoYear +'）': '' }}{{ poetry.mottoAuthor }}{{ poetry.mottoTitle? poetry.mottoTitle:'' }}</div>
          </div>
          <div class="translation">
            <span class="translation-title"></span>
            <span class="translationText">{{ poetry.mottoTranslation }}</span>
          </div>
        </div>
      </div>
<!--      <div class="subscribe">-->
<!--        <button class="subscribeTo" @click="isDialog=true">-->
<!--          <van-icon name="plus" />-->
<!--          <span>订阅</span>-->
<!--        </button>-->
<!--        <button class="subscribe-search" @click="isSearch=true">订阅查询</button>-->
<!--      </div>-->
      <!--      <div class="old-subscribe">-->
      <!--        <svg-icon iconClass='subscribe' className='icon' class="old-subscribe-icon"></svg-icon>-->
      <!--        <div class="old-subscribe-text">-->
      <!--          订阅开通“文津经典天天读”服务-->
      <!--&lt;!&ndash;          请访问旧版手机门户&ndash;&gt;-->
      <!--        </div>-->
      <!--        <div class="old-subscribe-go" @click="subscribeGo()">-->
      <!--          点击跳转-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <div class="small-class" v-if="smallList">
      <h1>微课堂</h1>
      <p class="small-class-introduce">
        为深化内容服务，满足公众多元的阅读需求，“文津经典诵读”项目推出“文津经典诵读微课堂”专栏，精选历年“文津经典诵读”精品讲座，采撷精彩片段，定期推送，以飨读者。
      </p>
      <van-swipe :stop-propagation="false" indicator-color="#008095" @change="onChange" ref="swipe">
        <van-swipe-item v-for="(item, index) in smallList.videoPath">
          <video @playing="videoPlaying" :ref="'videoClass'" controls controlsList="nodownload" :src="baseUrl+item.file" :poster="smallList.imgPath?baseUrl+smallList.imgPath:''"></video>
        </van-swipe-item>
      </van-swipe>
      <div class="small-class-content">
        <p class="small-class-content-title">{{ smallList.title }}</p>
        <p class="small-class-content-author">{{ smallList.lecturer }}</p>
        <p class="small-class-content-article">{{ smallList. content}}</p>
      </div>
    </div>
    <div class="collect-share">
      <div class="collect">
        <collect v-if="poetry" :resource="resource"></collect>
      </div>
    </div>
    <page-share :show="showShare" @show='getShow' :title="resource.module"></page-share>
    <version></version>
    <van-popup v-model="dateShow" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        @confirm="onConfirm"
        @cancel="dateShow = false"
        type="date"
        title="选择日期"
        :min-date="minDate"
        :max-date="maxDate"
      />
    </van-popup>
    <van-overlay :show="isDialog">
      <div class="wrapper" @click.stop>
        <div class="prompt">
          <div class="prompt-content">
            <div class="prompt-title">订阅<van-icon name="close" size="18" class="close" @click="isDialog=false"/></div>
            <div class="verification-code">
              <van-cell-group>
                <van-field v-model="subscribePhone" label="手机号：" placeholder="请输入手机号" />
                <van-field
                  v-model="subscribeCode"
                  center
                  clearable
                  label="验证码："
                  placeholder="验证码"
                  maxlength="6"
                >
                  <template #button>
                    <van-button class="getCode" @click="getCode('subscribe')" v-if="subscribeShow">获取验证码</van-button>
                    <van-button class="countdown" v-else>{{subscribeText}}s</van-button>
                  </template>
                </van-field>
              </van-cell-group>
            </div>
            <van-button class="subscribe-btn" @click="subscribeSms">订阅</van-button>
            <div class="pr-message-title">短信订阅</div>
            <div class="prompt-message subscribe-to">
              <p class="prompt-message-instructions">国家图书馆从2012年8月1日起，推出“文津经典天天读”服务，每天为读者介绍一条中华传统美德格言和一首古代诗词，通过106988106988发送至订阅手机。</p>
              <p><span class="prompt-note">短信订阅：</span>发送“SJDY—DYWJ”到106988106988</p>
              <p><span class="prompt-note">短信退订：</span>发送“SJDY—TDWJ”到106988106988</p>
            </div>
          </div>
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="isSearch">
      <div class="wrapper" @click.stop>
        <div class="prompt">
          <div class="prompt-content">
            <div class="prompt-title">订阅查询<van-icon name="close" size="18" class="close" @click="isSearch=false"/></div>
            <div class="verification-code">
              <van-cell-group>
                <van-field v-model="queryPhone" label="手机号：" placeholder="请输入手机号" />
                <van-field
                  v-model="queryCode"
                  center
                  clearable
                  label="验证码："
                  placeholder="验证码"
                  maxlength="6"
                >
                  <template #button>
                    <van-button class="getCode" @click="getCode('query')" v-if="queryShow">获取验证码</van-button>
                    <van-button class="countdown" v-else>{{queryText}}s</van-button>
                  </template>
                </van-field>
              </van-cell-group>
            </div>
            <van-button class="subscribe-btn" @click="querySms">查询</van-button>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Vue from 'vue'
import {Cell, CellGroup, List, Icon, Checkbox, Calendar, Toast, Dialog} from 'vant'
import { request } from '../../untils/request'
import navigation from '../../components/navigation'
import version from '../../components/version'
import pageShare from '../../components/pageShare'
import collect from '../../components/collect'

Vue.use(Cell).use(CellGroup).use(List).use(Icon).use(Checkbox).use(Calendar).use(Toast)
export default {
  name: 'read',
  components: {navigation, version, pageShare, collect},
  data () {
    return {
      baseUrl: process.env.API_ROOT,
      dateShow: false,
      todayPlay: true,
      poetry: '',
      minDate: new Date(2012, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      isDialog: false,
      isSearch:false,
      smallList: '',
      mottoPlay: true,
      virtuePlay: true,
      audioNodes: [], // 用于存放所有 audio 的 DOM 节点
      audioArr: {
        currentTime: '00:00',
        duration: '00:00'
      }, // 用于维护 audio 的总时长和当前播放时间的数组
      virtueArr: {
        currentTime: '00:00',
        duration: '00:00'
      }, // 用于维护 audio 的总时长和当前播放时间的数组
      // resource:{
      //   title: '',
      //   module: '文津经典诵读',
      //   resourceId:''
      // }
      lecture: '',
      resource:{},
      showShare: false,
      subscribeCode:'',
      queryCode: '',
      queryPhone: '',
      subscribePhone: '',
      timer: null,
      subscribeShow: true,
      subscribeText: '',
      timerQuery: null,
      queryShow: true,
      queryText: ''
    }
  },
  created () {
    window.scroll(0, 0)
    if (this.$route.query.time) {
      console.log('this.$route', this.$route)
      let date = this.$route.query.time
      this.getPoetryRead(date)
      this.getSmallRead(date)
    } else {
      // 文津
      this.getPoetry()
      // 微课堂
      this.getSmall()
    }
  },
  methods: {
    // 去旧版本订阅短信
    subscribeGo() {
      window.location.href='http://202.106.125.164/client/feature/dxdy.jsp?id=ff8080814fff422b014fff45eacc0000'
    },
    // 获取短信验证码
    getCode (type) {
      let params = {
        operation: type
      }
      if(this.validationPhone(type)===true) {
        if(type==='subscribe'){
          params.code = this.subscribePhone
        } else {
          params.code = this.queryPhone
        }
        request('post', '/nlc-web/api/poetryRead/smsCode', params).then(res => {
          console.log('获取短信验证码', res)
          if(res.code===200){
            if(type==='subscribe'){
              const TIME_COUNT = 60;
              if (!this.timer) {
                this.subscribeText = TIME_COUNT;
                this.subscribeShow = false;
                this.timer = setInterval(() => {
                  if (this.subscribeText > 0 && this.subscribeText <= TIME_COUNT) {
                    this.subscribeText--;
                  } else {
                    this.subscribeShow = true;
                    clearInterval(this.timer);
                    this.timer = null;
                  }
                }, 1000)
              }
            } else {
              const QUERY_TIME_COUNT = 60;
              if (!this.timerQuery) {
                this.queryText = QUERY_TIME_COUNT;
                this.queryShow = false;
                this.timerQuery = setInterval(() => {
                  if (this.queryText > 0 && this.queryText <= QUERY_TIME_COUNT) {
                    this.queryText--;
                  } else {
                    this.queryShow = true;
                    clearInterval(this.timerQuery);
                    this.timerQuery = null;
                  }
                }, 1000)
              }
            }
          }
        })
      }
    },
    // 短信验证码订阅
    subscribeSms  () {
      if(this.validationPhone('subscribe')===true && this.validation('subscribe')===true){
        let params = {
          code:this.subscribePhone,
          smsCode: this.subscribeCode
        }
        request('post', '/nlc-web/api/poetryRead/subscribeSms', params).then(res => {
          console.log('短信验证码订阅', res)
          if(res.code===200){
            this.subscribePhone=''
            this.subscribeCode=''
            Dialog.confirm({
              message: '订阅成功，请注意查收短信。',
              showCancelButton: false,
            }).then(() => {

            }).catch(() => {
              // on cancel
            })
          } else {
            if(res.msg){
              Dialog.confirm({
                message: res.msg,
                showCancelButton: false,
              }).then(() => {

              }).catch(() => {
                // on cancel
              })
              // Toast.fail(res.msg);
            } else {
              Dialog.confirm({
                message: '订阅失败，请您重新订阅。',
                showCancelButton: false,
              }).then(() => {

              }).catch(() => {
                // on cancel
              })
            }
          }
        })
      }
    },
    // 短信验证码查询
    querySms () {
      if(this.validationPhone('query')===true && this.validation('query')===true){
        let params = {
          code:this.queryPhone,
          smsCode: this.queryCode
        }
        request('post', '/nlc-web/api/poetryRead/query', params).then(res => {
          console.log('短信验证码查询', res)
          if(res.code===200){
            this.isSearch = false
            this.queryPhone =''
            this.queryCode =''
            if(res.data===true){
              Dialog.confirm({
                message: '您已订阅《文津经典诵读》。',
                showCancelButton: false,
              }).then(() => {

              }).catch(() => {
                // on cancel
              })
            } else {
              Dialog.confirm({
                message: '您未订阅《文津经典诵读》。',
                showCancelButton: false,
              }).then(() => {

              }).catch(() => {
                // on cancel
              })
            }
          } else {
            // Toast.fail(res.msg);
            Dialog.confirm({
              message: res.msg,
              showCancelButton: false,
            }).then(() => {

            }).catch(() => {
              // on cancel
            })
          }
        })
      }
    },
    // 验证手机号
    validationPhone (type){
      let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if(type==='subscribe'){
        if(this.subscribePhone!==''){
          if(reg_tel.test(this.subscribePhone)){
            return true
          } else {
            Toast('手机号格式不正确！');
          }
        } else {
          Toast('手机号不能为空！');
        }
      } else {
        if(this.queryPhone!==''){
          if(reg_tel.test(this.queryPhone)){
            return true
          } else {
            Toast('手机号格式不正确！');
          }
        } else {
          Toast('手机号不能为空！');
        }
      }
    },
    // 验证提交信息
    validation(type) {
      if(type==='subscribe'){
        console.log('this.subscribeCode',this.subscribeCode.length)
        if(this.subscribeCode!=='' && this.subscribeCode.length===6){
          return true
        } else if(this.subscribeCode.length<6) {
          Toast('验证码格式不正确！');
        } else {
          Toast('验证码不能为空！');
        }
      } else {
        if(this.queryCode!=='' && this.queryCode.length===6){
          return true
        } else if(this.queryCode.length<6) {
          Toast('验证码格式不正确！');
        } else {
          Toast('验证码不能为空！');
        }
      }
    },
    videoPlaying() {
      if(this.$refs.motto && this.$refs.motto.play) {
        this.mottoPlay = true
        this.$refs.motto.pause();
      }
      if (this.$refs.virtue && this.$refs.virtue.play){
        this.virtuePlay = true
        this.$refs.virtue.pause()
      }
    },
    // 返回上一页
    onClickLeft () {
      this.$router.go(-1)
    },
    review () {
      this.dateShow = true
    },
    // 获取内容
    getPoetry () {
      let date = new Date()
      let nowDate = this.getDate(date)
      this.getPoetryRead(nowDate)
    },
    // 往期回顾
    onConfirm (date) {
      this.dateShow = false
      console.log('date', date)
      let nowDate = this.getDate(date)
      this.getPoetryRead(nowDate)
      this.getSmallRead(nowDate)
    },
    // 微课堂
    getSmall () {
      let date = new Date()
      let nowDate = this.getDate(date)
      this.getSmallRead(nowDate)
    },
    // 微阅读详情
    getSmallRead (date) {
      let params = {
        releaseDate: date
      }
      request('post', '/nlc-web/api/poetryRead/findClassByDate', params).then(res => {
        console.log('微课堂详情', res)
        if (res.code===200) {
          res.data.videoPath = JSON.parse(res.data.videoPath)
          this.smallList = res.data
        } else {
          this.smallList = ''
        }
      })
    },
    // 文津详情
    getPoetryRead (date) {
      var releaseDate = {
        releaseDate: date
      }
      request('post', '/nlc-web/api/poetryRead/date', releaseDate).then(res => {
        console.log('详情', res)
        if (res.code!==200) {
          Toast.fail('当日无数据')
        } else {
          this.poetry = res.data
          this.resource = {
            title: res.data.collectionTitle,
            module: '文津经典诵读',
            resourceId: res.data.id
          }
          // 重新加载音频
          this.$refs.motto.load()
          this.audioEnded(1)
          let progressTag = document.getElementsByClassName('timeBar')[0]
          progressTag.style.width = `0%`

          this.$refs.virtue.load()
          this.audioEnded(2)
          let progressTagV = document.getElementsByClassName('timeBarV')[0]
          progressTagV.style.width = `0%`
        }
      })
    },
    // 诗词名句音频播放
    mottoAudio () {
      if (this.mottoPlay === true) {
        this.mottoPlay = false
        let promise = this.$refs.motto.play();
        promise.then(() => {
          if (this.$refs.videoClass && this.$refs.videoClass.length>0) {
            this.$refs.videoClass.forEach(video => {
              if (video.play) {
                video.pause()
              }
            })
          }
          if (this.$refs.virtue.play) {
            this.virtuePlay = true
            this.$refs.virtue.pause()
          }
        })
      } else {
        this.mottoPlay = true
        this.$refs.motto.pause()
      }
    },
    // 美德格言音频播放
    play () {
      let promise = this.$refs.virtue.play();
      promise.then(() => {
        if (this.$refs.videoClass && this.$refs.videoClass.length>0) {
          this.$refs.videoClass.forEach(video => {
            if (video.play) {
              video.pause()
            }
          })
        }
        if(this.$refs.motto.play){
          this.mottoPlay = true
          this.$refs.motto.pause()
        }
      })
      this.virtuePlay = false
      // this.$refs.virtue.play()
    },
    // 美德格言音频暂停
    pause () {
      this.virtuePlay = true
      this.$refs.virtue.pause()
    },
    // 获取音频的总时长
    fillTime (event) {
      this.audioArr.duration = this.transTime(event.target.duration)
      this.virtueArr.duration = this.transTime(event.target.duration)
    },

    // 将秒数转化成(分:秒)格式
    transTime (time) {
      let duration = parseInt(time)
      let minute = parseInt(duration / 60).toString().padStart(2, '0')
      let sec = (duration % 60).toString().padStart(2, '0')
      return `${minute}:${sec}`
    },

    // 进度条播放的事件
    updateProgress () {
      let audio = this.$refs.motto
      if (audio) {
        let value = Math.round((Math.floor(audio.currentTime) / Math.floor(audio.duration)) * 100, 0)
        this.audioArr.currentTime = this.transTime(audio.currentTime)
        let progressTag = document.getElementsByClassName('timeBar')[0]
        progressTag.style.width = `${value}%`
      }
      let audioV = this.$refs.virtue
      if (audioV) {
        let valueV = Math.round((Math.floor(audioV.currentTime) / Math.floor(audioV.duration)) * 100, 0)
        this.virtueArr.currentTime = this.transTime(audioV.currentTime)
        let progressTagV = document.getElementsByClassName('timeBarV')[0]
        progressTagV.style.width = `${valueV}%`
      }
    },

    // 播放结束的处理动作
    audioEnded (type) {
      if (type===1) {
        let audio = this.$refs.motto
        audio.currentTime = 0
        audio.pause()
        this.mottoPlay = true
      }
      if (type===2) {
        let audioV = this.$refs.virtue
        audioV.currentTime = 0
        audioV.pause()
        this.virtuePlay = true
      }
    },

    // 日期格式更改
    getDate (date) {
      let year = date.getFullYear() // 年
      let month = (date.getMonth() + 1).toString().padStart(2, 0) // 月
      let day = date.getDate().toString().padStart(2, 0) // 日
      return `${year}-${month}-${day}`
    },
    // 文字换行
    text (str, keyword) {
      var a = [] // 存。下标
      for (var k = 0; k < str.length; k++) {
        if (str.charAt(k) === keyword) {
          a.push(k)
        }
      }

      var str1 = ''// 存dom
      var texthtml = ''// 存字段
      for (var p = 0; p < a.length; p++) { // 循环字段
        if (p > 0) {
          texthtml = str.substring(a[p - 1] + 1, a[p] + 1)
        } else {
          texthtml = str.substring(0, a[p] + 1)
        }
        str1 += '<div>' + texthtml + '</div>'
      }
      return str1
    },
    share () {
      this.showShare = true
    },
    getShow (msg) {
      this.showShare = msg
    },
    onChange () {
      if (this.$refs.videoClass && this.$refs.videoClass.length>0) {
        this.$refs.videoClass.forEach(video => {
          if (video.play) {
            video.pause()
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.app-container{
  background:#ecf5fd;
  overflow-y:scroll;
}
.content{
  width: 6.47rem;
  margin:1.08rem .28rem .16rem .28rem;
  background:#fff;
  border-radius:8px;
  padding:.1rem .24rem;
}
.date{
  font-size:.36rem;
}
.audio{
  width:5.57rem;
  height:.86rem;
  background-size:100%;
  position:relative;
}
.today-audio{
  margin:.32rem .2rem -.64rem .7rem;
}
.motto-audio{
  margin:.32rem .2rem -.64rem .7rem;
}
.motto-audio audio {
  height:0;
}
.motto-left{
  width:1.59rem;
  height:1.59rem;
  /*background:url("../../assets/img/record-bg.png") no-repeat;*/
  background-size:100% 100%;
  position:absolute;
  left:-.81rem;
  top:-.2rem;
}
.motto-left img{
  position: absolute;
  left: .66rem;
  top: .46rem;
  width: .3rem;
  height: .3rem;
}
.motto-right{
  margin-left:.78rem;
  padding-top:.35rem
}
.progress-strip{
  width:4.34rem;
}
.progressBar {
  position: relative;
  width: 100%;
  height:.06rem;
  background: #fff;
  border-radius:6px;
}
.timeBar, .timeBarV{
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  /*background-color: #0B83A1;*/
  border-radius:6px;
}
.time{
  font-size:.2rem;
  color:#333;
  position:relative;
  margin-top:.05rem;
}
.time-start{
  position: absolute;
  left:0;
}
.time-end{
  position: absolute;
  right:.45rem;
}
.today-date{
  padding:.1rem .28rem;
  text-align:center;
  font-family: SourceHanSerifCN-Regular;
}
.today-date p{
  margin:0;
}
.dayOfMonth{
  font-size: .4rem;
  font-family: SourceHanSansCN-Heavy;
  font-weight: 800;
  color: #46484B;
  height:.45rem;
}
.weekday{
  padding:.33rem .26rem;
  font-family: SourceHanSerifCN-SemiBold;
}
.chineseYear{
  font-family: SourceHanSerifCN-Regular;
  padding:.32rem .28rem;
}
.previous{
  text-align:center;
  padding:.16rem .2rem;
  font-family: SourceHanSerifCN-Medium;
}
.calendar-detail{
  width:6.47rem;
  height:1rem;
  /*background:url("../../assets/img/pr-bg.png") no-repeat;*/
  background-size:100%;
  margin:.32rem 0;
  display:flex;
  font-size:.24rem;
}
.poetry-title{
  font-weight:bold;
  font-size: .36rem;
  font-family: SourceHanSerifCN-SemiBold;
}
.translation{
  position:relative;
  width:5.52rem;
  line-height:.35rem;
  font-size:.26rem;
  /*background: #e2f0f3;*/
  border-radius:8px;
  padding:.13rem .23rem;
  margin-top:.16rem;
  font-family: SourceHanSerifCN-Light;
  display:flex;
}
.translation-title{
  width:.26rem;
  display:inline-block;
  margin-right:.08rem;
  /*background:url('../../assets/img/translation.png') no-repeat 0 .05rem;*/
  background-size:100%;
}
.translationText{
  width:5.28rem;
  display:inline-block;
}
.poem{
  width:6.14rem;
  text-align:center;
  font-size:.28rem;
  padding-bottom:.25rem;
  color: #414649;
  font-family: SourceHanSerifCN-Regular;
}
.subscribe{
  display:flex;
  margin:.24rem 0 .29rem 0;
}
.subscribeTo{
  width:4.52rem;
  height:.64rem;
  border-radius: 8px;
  font-size:.3rem;
  color:#444649;
  font-family: SourceHanSerifCN-Heavy;
}
.subscribeTo span{
  vertical-align: middle;
}
.subscribe-search{
  width:1.82rem;
  height:.64rem;
  border-radius: 8px;
  font-size:.3rem;
  color:#444649;
  margin-left:.12rem;
  padding:0;
  font-family: SourceHanSerifCN-Heavy;
}
>>>.van-icon-plus{
  vertical-align: middle;
  line-height: .2rem;
}
.wrapper{
  font-size:.28rem;
  color:#444649;
  width: 100%;
  height: 100%;
  display:flex;
  align-items: center;
  justify-content: center;
}
.prompt{
  width: 4.9rem;
  background:#fff;
  font-size:.24rem;
  color:#47494c;
  border-radius:16px;
  padding:.34rem .3rem;
}
.prompt-title{
  font-size:.36rem;
  /*color:#008095;*/
  position:relative;
}
.close{
  position:absolute;
  right:.1rem;
}
/*.prompt-note{*/
/*  color:#008095;*/
/*}*/
.small-class{
  width:6.38rem;
  background:#fff;
  margin:.16rem .28rem;
  padding:0 .28rem .41rem .28rem;
  font-size:.28rem;
  color:#444649;
  border-radius:8px;
  overflow-x:hidden;
}
.small-class-introduce{
  margin:.24rem 0 0 0;
  font-family: SourceHanSerifCN-Light;
  text-align: justify;
}
h1{
  font-size:.36rem;
  color:#444649;
  padding-top:.44rem;
  margin:0;
  font-family: SourceHanSerifCN-SemiBold;
}
.small-class-content{
  font-family: SourceHanSerifCN-Light;
  text-align: justify;
}
.small-class-content-title{
  font-size: .3rem;
  font-weight:bold;
  font-family: SourceHanSerifCN-SemiBold;
}
.small-class-content-title,.small-class-content-author{
  text-align:center;
  margin:.1rem 0 0 0;
}
video,audio{
  width:100%;
}
.van-swipe__indicator{
  background:#81b8c2 !important;
}
.poetry-text{
  width:6.04rem;
  /*border:2px solid #008095;*/
  border-radius:8px;
  margin-top:.32rem;
  font-size:.24rem;
  padding:.4rem .2rem 0 .2rem;
  background: url("../../assets/img/pr-content-bg.png") no-repeat center bottom;
  background-size:100%;
  margin-bottom:.34rem;
}
.motto-text{
  width:6.04rem;
  /*border:2px solid #008095;*/
  border-radius:8px;
  font-size:.24rem;
  padding:.4rem .2rem .38rem .2rem;
  margin-top:.32rem;
  background: url("../../assets/img/pr-motto-bg.png") no-repeat center bottom;
  background-size:100%;
}
.poetry-details{
  color: #444649;
}
.poetry-details-text{
  text-align:left;
  font-size: .3rem;
  font-family: SourceHanSerifCN-Regular;
  padding: 0 .55rem;
}
.poetry-details-source{
  text-align:right;
  font-size: .24rem;
  font-family: SourceHanSerifCN-Regular;
  padding-top:.16rem;
}
.fullText{
  font-family: SourceHanSerifCN-Regular;
  color:#797C81;
  line-height: .5rem;
}
.bar{
  width:.02rem;
  height:.48rem;
  background:#47494C;
  display:inline-block;
  margin-top:.26rem;
}
.collect-share{
  display:flex;
  background:#fff;
  border-radius:8px;
  margin:0 .28rem;
  height: 1rem;
  line-height: 1rem;
}
.share{
  color:#444649;
  font-size:.24rem;
  margin-left:.22rem;
  line-height: .57rem;
}
*	{
  touch-action:none;
  touch-action:pan-y;
}
>>>.van-swipe{
  margin-top:.24rem;
}
.verification-code{
  margin-top:.18rem;
}
.verification-code >>>.van-cell{
  padding:.2rem 0;
  background:none;
}
.verification-code >>>.van-field__label{
  width:1.2rem;
  margin-right:0;
  font-size:.28rem;
}
.getCode{
  width: 1.8rem;
  height: .68rem;
  border-radius: 60px;
  font-size:.24rem;
}
.pr-message-title{
  font-size:.36rem;
  margin:.34rem 0 .12rem 0;
}
.prompt-message{
  border-radius: 8px;
  padding:.17rem;
}
.prompt-message p{
  margin:0;
  line-height:.36rem;
}
.prompt-message-instructions{
  border-bottom:1px solid #DCE5ED;
  padding-bottom:.1rem;
  margin-bottom:.1rem !important;
}
.subscribe-btn{
  width: 5rem;
  height: .88rem;
  border-radius: 60px;
  margin-top:.29rem;
  color:#fff;
  font-size:.36rem;
}
.countdown{
  width: 2.14rem;
  height: .68rem;
  border-radius: 60px;
  border:1px solid #cccfd3;
  background:#cccfd3;
  color:#fff;
}
>>>.van-cell::after{
  right:0;
  left:0;
}
>>>.van-cell-group{
  border:0;
}
>>>.van-hairline--top-bottom::after{
  border-top:0;
}
video::-internal-media-controls-download-button {  display:none;}
video::-webkit-media-controls-enclosure {  overflow:hidden;}
video::-webkit-media-controls-panel {  width: calc(100% + 30px); }

.old-subscribe{
  width:6.47rem;
  height:1.11rem;
  background: #E2F0F3;
  border-radius: 8px;
  margin:.32rem 0;
  display:flex;
  font-size:.28rem;
}
.old-subscribe-icon{
  margin:.42rem .14rem .41rem .27rem;
}
.old-subscribe-text{
  width:3.88rem;
  font-weight: 300;
  color: #008095;
  margin-top:.36rem;
}
.old-subscribe-go{
  width: 1.3rem;
  height: .44rem;
  background: #008095;
  border-radius: 8px;
  color:#fff;
  text-align:center;
  line-height:.44rem;
  margin:.35rem 0 0 .41rem;
  font-size:.24rem;
  font-weight: 500;
}
>>>.van-field__button{
  padding-left:.08rem;
}
>>>.van-button--normal{
  padding:0;
}
</style>



// WEBPACK FOOTER //
// src/view/poetryRead/index.vue